import { useState } from 'react';

type Props = { environmentId: string };

const TerminalEnvPanel = ({ environmentId }: Props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard?.writeText(environmentId);
    setCopied(true);
  };

  return (
    <div className="bg-light-primary rounded p-4 mt-3">
      <div className="text-gray-600 fs-7 mb-2">
        No app do terminal, insira o ID do ambiente abaixo. Assim que o dispositivo se registrar, o próximo passo é
        liberado.
      </div>
      <div className="d-flex align-items-center gap-2">
        <code
          className="bg-white border border-gray-300 rounded px-3 py-2 fw-bold flex-grow-1"
          data-testid="environment-id"
        >
          {environmentId}
        </code>
        <button type="button" className="btn btn-sm btn-light-primary" onClick={handleCopy}>
          {copied ? 'Copiado!' : 'Copiar'}
        </button>
      </div>
    </div>
  );
};

export default TerminalEnvPanel;
